import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useModules } from '../../context/FeatureContext';
import ChatbotDashboard from './ChatbotDashboard';

// /chatbot used to be its own page. Web-chat leads now live in AI receptionist (the "Web chat"
// channel of the lead list) and the switch and embed code in Settings → AI receptionist →
// Website chat, so the old address lands on the web-chat leads.
//
// An organisation that has website chat but not the AI receptionist module keeps the standalone
// page, so nothing it could do before is lost. (That page is also what shows for a moment while
// the organisation's module grants are still loading.)
const WEB_CHAT_LEADS = '?tab=all&channel=web_chat';

export default function ChatbotRedirect() {
  const { user } = useAuth();
  const modules = useModules();
  if (user?.role === 'super_admin') return <Navigate to={`/receptionist${WEB_CHAT_LEADS}`} replace />;
  if (modules.ai_receptionist === true) return <Navigate to={`/ai-receptionist${WEB_CHAT_LEADS}`} replace />;
  return <ChatbotDashboard />;
}
